module.exports = __webpack_public_path__ + "img/9.48a501d6.png";